export default __webpack_public_path__ + "3e3e867200cb2000fbd2c75189a1a8d1.png";